var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"navbar-toggler",attrs:{"type":"button","aria-label":"Navbar toggle button"}},[_c('ui-icon',{attrs:{"name":"bar","size":"30px"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }